<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectItemIndicator, type SelectItemIndicatorProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectItemIndicatorProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectItemIndicatorProps>;
</script>

<template>
  <SelectItemIndicator v-bind="forwarded">
    <slot />
  </SelectItemIndicator>
</template>
